<template>
  <commonTable
    :fields="workorderTableFields"
    :items="workorderItem"
    :otherTheme="'thead-green'"
  >
    <template #cell(work_qty)="data">
      {{ data.value.toLocaleString("en-US") }}
    </template>
  </commonTable>
</template>
  
  <script>
import commonTable from "@/components/commonTable.vue";
import { ref } from "vue";
export default {
  name: "workorderTable",
  components: {
    commonTable,
  },
  props: {
    workorderItem: {
      type: Array,
      default: [],
    },
  },
  setup() {
    //查詢結果表格
    const workorderTableFields = ref([
      {
        key: "work_code",
        label: "工單編號",
        thStyle: {
          "min-width": "105px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "comm_code",
        label: "料號",
        thStyle: {
          "min-width": "230px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "control_card",
        label: "管制卡號",
        thStyle: {
          "min-width": "185px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "comm_name",
        label: "料名",
        thStyle: {
          "min-width": "500px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "work_qty",
        label: "派工支數",
        thStyle: {
          "min-width": "105px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
    ]);

    return {
      workorderTableFields,
    };
  },
};
</script>
  
  <style></style>
  